import types from '../../../mutation-types';

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('conversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

export const isOnWlabAiAgentView = ({ route: { name: routeName } }) => {
  const WLAB_AI_AGENT_ROUTES = [
    'conversation_wlab_ai_agent_all',
    'conversation_through_wlab_ai_agent_all',
    'conversation_wlab_ai_agent_resolved',
    'conversation_through_wlab_ai_agent_resolved',
    'conversation_wlab_ai_agent_handoff',
    'conversation_through_wlab_ai_agent_handoff',
    'conversation_wlab_ai_agent_pending',
    'conversation_through_wlab_ai_agent_pending',
  ];
  return WLAB_AI_AGENT_ROUTES.includes(routeName);
};

export const getWlabAiAgentViewType = ({ route: { name: routeName } }) => {
  if (routeName?.includes('wlab_ai_agent_pending')) return 'pending';
  if (routeName?.includes('wlab_ai_agent_resolved')) return 'resolved';
  if (routeName?.includes('wlab_ai_agent_handoff')) return 'handoff';
  if (routeName?.includes('wlab_ai_agent_all')) return 'all';
  return null;
};

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType
) => {
  const { payload: conversationList, meta: metaData } = responseData;

  // First-page fetches (initial mount, filter/folder change, mark-all-read
  // refresh) are "fresh" — the response is a complete snapshot of what the
  // user expects to see. We use replace mode so stale items from earlier
  // fetches are evicted, preventing the "list shows items the server has
  // already marked as read" mismatch.
  //
  // Pagination (page > 1) and reconnect delta sync (page=null with
  // updatedWithin) keep merge semantics so already-loaded items stay.
  const isFreshFetch = Number(requestPayload && requestPayload.page) === 1;
  context.commit(types.SET_ALL_CONVERSATION, {
    conversations: conversationList,
    replace: isFreshFetch,
  });
  if (metaData && Object.keys(metaData).length > 0) {
    context.dispatch('conversationStats/set', metaData);
  }
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  context.commit(types.CLEAR_LIST_LOADING_STATUS);
  setContacts(context.commit, conversationList);

  // Mark end reached if:
  // 1. No conversations returned (empty list)
  // 2. Returned less than 25 conversations (the page size)
  const CONVERSATIONS_PER_PAGE = 25;
  const hasReachedEnd = conversationList.length < CONVERSATIONS_PER_PAGE;

  setPageFilter({
    dispatch: context.dispatch,
    filter: filterType,
    page: requestPayload.page,
    markEndReached: hasReachedEnd,
  });
};
